module.exports = __webpack_public_path__ + "static/flags/KZ-c369d901fe7469535bffb4ff30a187ae.gif";